module.exports = __webpack_public_path__ + "static/media/js.7f130501.png";